import { colors } from '../../colors';
var socialIcon = {
  fillColor: colors.black,
  fillHoverColor: colors.white,
  iconColor: colors.white,
  iconHoverColor: colors.dirtyBlue,
  iconBorderColor: colors.white,
  iconBorderHoverColor: colors.dirtyBlue
};
export default socialIcon;